__webpack_require__.p = "/demo-portfolio-for-assessment-advanced-react-course/";